import { render } from "./SearchSidebar.vue?vue&type=template&id=20a14bd8&scoped=true"
import script from "./SearchSidebar.vue?vue&type=script&lang=js"
export * from "./SearchSidebar.vue?vue&type=script&lang=js"

import "./SearchSidebar.vue?vue&type=style&index=0&id=20a14bd8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a14bd8"]])

export default __exports__